import { render, staticRenderFns } from "./AutomatOrNonAutomate.vue?vue&type=template&id=fe01b716"
import script from "./AutomatOrNonAutomate.vue?vue&type=script&lang=js"
export * from "./AutomatOrNonAutomate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports